document.addEventListener("rebuy.beforeLoaded", function (event) {
  window.Rebuy.disable_attribution = true;
});

document.addEventListener('page:loaded', function() {
  var footerNewsletterForm = document.querySelector(".footer__newsletter form");
  if (footerNewsletterForm) {
    var footerNewsletterFormInputs =
      footerNewsletterForm.querySelectorAll("input");
    for (var inputs of footerNewsletterFormInputs) {
      inputs.addEventListener("focus", function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "SnV2f6"]);
      });
    }
  }
});
